package org.hs_soft.runmynesto.navigation

sealed class Screen(val route:String)
{
    data object Index:Screen(route = "/")
    data object Login:Screen(route = "/login/")
    data object HomePage: Screen(route = "/home/")
    data object Product:Screen(route = "/product/sub-page/product/")
}